import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import styles from "./EstimatedDeliveryComponent.module.scss";
import { merchandise_shiprocket_error } from "../../MerchandiseDetailsFormGroup.constants";

type IEstimatedDeliveryComponent = {
    shippingDate: string;
    showError?: boolean;
};

const EstimatedDeliveryComponent = ({
    shippingDate,
    showError = false,
}: IEstimatedDeliveryComponent) => {
    if (!shippingDate && !showError) {
        return <></>;
    }

    return (
        <>
            {showError ? (
                <div className={styles.mainContainer}>
                    <LocalShippingRoundedIcon
                        className={classNames(
                            styles.iconStyles,
                            styles.errorStyles
                        )}
                    />
                    <div
                        className={classNames(
                            styles.textStyles,
                            styles.errorStyles
                        )}
                    >
                        {merchandise_shiprocket_error}
                    </div>
                </div>
            ) : (
                <div className={styles.mainContainer}>
                    <LocalShippingRoundedIcon className={styles.iconStyles} />
                    <div className={styles.textStyles}>
                        Estimated Delivery by{" "}
                        <span className={styles.dateStyles}>
                            {shippingDate}
                        </span>
                    </div>
                </div>
            )}
        </>
    );
};

export default EstimatedDeliveryComponent;

EstimatedDeliveryComponent.defaultProps = {
    showError: false,
};
